import React from "react";

/**
 * GeneratePlanButton component for navigating to the GeneratePlan page.
 */

import { useNavigate } from "react-router-dom";
import ArticleOutlinedIcon from "@mui/icons-material/ArticleOutlined";

const GeneratePlanButton: React.FC<{ className?: string }> = ({
  className = "",
}) => {
  const navigate = useNavigate();

  const handleNavigate = (path: string) => {
    navigate(path);
  };

  return (
    <button
      className="px-6 my-1 text-base font-medium border-none rounded-full outline-none text-primary-content bg-accent btn flex-nowrap whitespace-nowrap"
      onClick={() => handleNavigate("/genera-piano")}
    >
      <ArticleOutlinedIcon className="w-4" />
      Genera piano editoriale
    </button>
  );
};

export default GeneratePlanButton;
